export default __webpack_public_path__ + "static/media/pink-bag-active.0db80c75.png";